module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAoElEQVR42pXPsRECIRCFYWY01kLUxF60AwM4D1gGh3RL0DZoxdTQArSAy4Vg031Ctsx8P4txMWXv896MneboXmtdmYnKzgX69MgIbuYpc4vks0T+xaWUbZ9BBGMQARhGMMYRBeOI9bTYQK8xLGuH9LA+vl2k75XoMIxlbRvSqX+nR4bwzLyROyWCMYgADCMY48gUb0cFqxF5/aJgNcLM6x91O5mxCOB8FwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/p-close_1x.png
// module id = 1003
// module chunks = 0